

// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Details from "./Page/Details";
// import Home from "./Page/Home";
import "splitting/dist/splitting-cells.css";
import "splitting/dist/splitting.css";
import { useEffect } from "react";
import gsap from "gsap";
import { TweenLite } from "gsap/all";
// import Product from "./Page/Product";
// import ScrollPageAnimation from "./Page/ScrollPageAnimation";
import Lenis from '@studio-freight/lenis';
// import RedBull from "./Page/RedBull";
import ProductInfoWithZoom from "./Page/ProductInfoWithZoom";

function App() {

	useEffect(() => {

		const lenis = new Lenis({
			duration: 1.9,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
			direction: "vertical",
			gestureDirection: "vertical",
			smooth: true,
			smoothTouch: false,
		});

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}

		requestAnimationFrame(raf);

		let ctx = gsap.context(() => {
			var circle = document.querySelector(".cursor-outline");

			TweenLite.set(circle, {
				xPercent: -50,
				yPercent: -50
			});

			window.addEventListener("mousemove", moveCircle);

			function moveCircle(e) {
				TweenLite.to(circle, 0.3, {
					x: e.clientX,
					y: e.clientY
				});
			}
		});
		return () => ctx.revert();

	})

	return (
		<div>


			<div id="luxy">
				{/* <div> */}
				{/* <Router>
					<Routes> */}
				{/* <Route path="/" exact element={<ScrollPageAnimation />} /> */}


				{/* <Product /> */}
				{/* <RedBull /> */}
				<ProductInfoWithZoom />
				{/* </Routes>
				</Router> */}

			</div>
			<div className="cursor-outline"></div>
			{/* <div class="cursor-dot"></div> */}
		</div>

	);
}

export default App;
